<template>
    <v-card elevation="3" min-width="540px">
        <v-card-title>
            <router-link class="d-flex justify-center align-center text-decoration-none" to="/">
                <div class="text-black d-flex flex-column align-center">
                    <v-img :src="logo" :width="75" draggable="false"/>
                    <v-img :src="logoText" :width="100" draggable="false"/>
                </div>
            </router-link>
        </v-card-title>
        <v-card-title>Enter Authentication Code</v-card-title>
        <v-card-text>
            <v-form>
                <v-otp-input v-model="formData.otp" :length="6"/>

                <div class="mb-3">
                    <v-btn plain size="small" variant="plain" @click="navigateTo('forgot-password')">Resend code</v-btn>
                </div>

                <v-btn :disabled="!formData.valid" block color="primary" @click="submit">Authenticate</v-btn>
            </v-form>
        </v-card-text>
    </v-card>
</template>

<script setup>
import {reactive, watch} from "vue";
import logo from "@/assets/images/logo-1.png";
import logoText from "@/assets/images/logo-text.png";
import {useNavigation} from '@/composables/globals';
import {useSnackbarStore} from "@/stores/snackBarStore";

const {navigateTo} = useNavigation()
const {showSnackbar} = useSnackbarStore();
const formData = reactive({
    otp: '',
    valid: false
})

watch(() => formData.otp, (value) => {
    formData.valid = value.length === 6
})

const submit = () => {
    showSnackbar('Form submitted!')
}
</script>

<style scoped>

</style>
